export default __webpack_public_path__ + "static/media/first.96919da8.png";